<template>
  <div class="flex flex-col">
    <div v-if="selectedCountry" class="p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div class="flex items-center">
        <i class="fa fa-flag text-blue text-xl mr-3"></i>
        <div>
          <p class="text-sm text-gray-500 uppercase tracking-wide">Country</p>
          <p class="text-lg font-semibold text-gray-900">{{ selectedCountry.name }}</p>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-8 text-gray-500 text-sm">
      <i class="fa fa-globe text-3xl mb-2"></i>
      <p>No country selected</p>
    </div>
  </div>
</template>

<script>
import {api} from "../../../../../../../../app/services/api.service";

export default {
  name: 'CountryView',
  props: {
    data: {
      type: String,
      default: '',
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      countries: [],
      selectedCountry: null,
    };
  },
  watch: {
    data: {
      handler(val) {
        if (val && this.countries.length > 0) {
          this.selectedCountry = this.countries.find(function (c) { return c.id === val; }) || null;
        } else if (!val) {
          this.selectedCountry = null;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchCountries();
  },
  methods: {
    fetchCountries() {
      var self = this;
      if (api) {
        if (this.data) this.selectedCountry = { id: this.data, name: this.data, code: '' };
        return;
      }
      api().get('/configuration/address/country')
        .then(function (res) {
          var list = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
          self.countries = list;
          if (self.data && list.length > 0) {
            self.selectedCountry = list.find(function (c) { return c.id === self.data; }) || null;
          }
        })
        .catch(function () {});
    },
  },
};
</script>

<style scoped>
.flex { display: flex; }
.flex-col { flex-direction: column; }
</style>
